import React, { Component } from "react";
import BaseComponent from "../../BaseComponent.js";
import styled from "styled-components";
import nota from "../../Global/nota.guidelines.json";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";

import Input from "../../Nano/Input.js";
import Grid from "../../Macro/Grid.js";
import WrapperList from "./../../Nano/WrapperList.js";
import ViewMore from "./../../Nano/ViewMore.js";
import TitleCard from "./../../Nano/TitleCard.js";
import Spinner from "./../../Nano/Spinner.js";
import Modal from "../../Global/Modal.js";
import DeleteContent from "../../Micro/DeleteContent.js";
import ModalContent from "../../Micro/ModalContent.js";
import EditSavedSearchModal from "../../Micro/EditSavedSearchModal.js";

//IMAGES
import { ReactComponent as SearchIcon } from "../../Global/Icons/search.svg";
import { ReactComponent as Edit } from "../../Global/Icons/edit.svg";
import { ReactComponent as Duplicate } from "../../Global/Icons/duplicate.svg";
import { ReactComponent as Delete } from "../../Global/Icons/delete.svg";
import { ReactComponent as Check } from "../../Global/Icons/check.svg";
import { ReactComponent as Favorite } from "../../Global/Icons/favCrown.svg";
import { ReactComponent as CreatDate } from "../../Global/Icons/createDate.svg";
import { ReactComponent as EditDate } from "../../Global/Icons/editDate.svg";
import Loading from "./../../Nano/Loading.js";

import searchService from "../../../services/SearchService.js";

const multiple = nota.global.multiple;

const StyledSavedSearchesManagement = styled(NanoFlex)`
  height: 100%;
  padding: ${multiple * 2 + "px"};

  .headerWrapper {
    height: auto;
    h2 {
      text-transform: uppercase;
      em {
        text-transform: none;
        font-weight: bold;
        color: ${nota.color.main.default};
      }
    }
    p {
      margin-left: ${multiple * 2 + "px"};
      margin-bottom: 2px;
    }
  }

  .secondaryWrapper {
    height: auto;
    margin: ${multiple * 3 + "px"} 0;
  }

  /* BUTTON ICON --- secondaryWrapper */
  .iconBtnsWrapper {
    width: 310px;
    height: auto;
    user-select: none;
    cursor: pointer;
    padding: 9px ${multiple * 2 + "px"};
    background-color: ${nota.color.main.default};
    margin-right: ${multiple * 2 + "px"};
    svg {
      width: 20px;
      height: 20px;
      path {
        fill: ${nota.color.neutral.white};
      }
    }
    p {
      margin-left: ${multiple + "px"};
      color: ${nota.color.neutral.white};
    }
    &:hover {
      opacity: 0.7;
    }
  }
  /* INPUT --- secondaryWrapper */
  .inputWrapper {
    width: 360px;
    position: relative;
    .inputContainer {
      width: 100%;
      margin: 0;
      input {
        padding-right: 40px;
      }
    }
    .searchIconWrapper {
      position: absolute;
      right: ${multiple + "px"};
      top: 0;
      width: ${multiple * 3 + "px"};
      svg {
        width: 18px;
        height: 18px;
        path {
          fill: ${nota.color.main.default};
        }
      }
    }
  }

  /* LIST */
  .listContainer {
    height: auto;

    .itemContainer {
      margin-bottom: ${multiple * 2 + "px"};
      .wrapperList {
        margin: 0;
        /* border-top: 1px solid ${nota.color.main.default}; */
        padding: 0;

        .wrapperListContainer {
          .leftAsideItem {
            padding: ${multiple * 2 + "px"};
            /* width: calc(100% - 413px); */

            .titleCard {
              margin-left: ${multiple / 2 + "px"};
              margin-bottom: ${multiple / 2 + "px"};
              height: auto;
              h3 {
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                overflow: hidden;
              }
            }
            .descriptionWrapper {
              margin-left: ${multiple / 2 + "px"};
              margin-bottom: ${multiple + "px"};
              height: auto;
              p {
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                overflow: hidden;
              }
            }
            .noInfo {
              margin-bottom: ${multiple + "px"};
              font-size: 12px;
              color: ${nota.color.neutral.NeuThree};
              line-height: unset;
            }

            .gridContainer {
              .gridWrapper {
                align-items: flex-start;
              }
              .emptyGrid {
                min-height: 200px;
                margin: ${multiple / 2 + "px"};
                background-color: ${nota.color.neutral.NeuFour};
                p {
                  text-transform: uppercase;
                }
              }
              .loadingGrid {
                height: 200px;
              }
            }
          }
          .rightAsideItem {
            /* width: 413px; */
            width: auto;
            padding: ${multiple * 2 + "px"};
            background: ${nota.color.neutral.lightGrey};
            .optionsItemWrapper {
              /* padding: ${multiple * 5 + "px"}; */
              .optionsContainer {
                width: auto;
                .btnsWrapper {
                  height: auto;
                  user-select: none;
                  .selectBtn {
                    width: 240px;
                    .optionWrapper {
                      background-color: ${nota.color.neutral.NeuFour};
                      width: 100%;
                      cursor: pointer;
                      margin-bottom: ${multiple + "px"};
                      padding: ${multiple + "px"};
                      p {
                        text-transform: uppercase;
                      }
                      .checkBoxWrapper {
                        height: 100%;
                        width: 35px;
                        padding-left: 5px;
                        svg {
                          width: 18px;
                          height: 10px;
                          path {
                            fill: ${nota.color.neutral.NeuThree};
                          }
                        }
                      }

                      &:hover {
                        opacity: 0.7;
                      }
                    }
                    .selectedOption {
                      background-color: ${nota.color.main.default};
                      p {
                        color: ${nota.color.neutral.white};
                      }
                      .checkBoxWrapper {
                        svg {
                          path {
                            fill: ${nota.color.neutral.white};
                          }
                        }
                      }
                    }
                  }
                  .favBtn {
                    width: auto;
                    margin-top: 8px;
                    .optionWrapper {
                      margin-bottom: 0;
                      border-radius: 20px;
                      background-color: ${nota.color.neutral.white};
                      border: 1px solid ${nota.color.main.mThree};
                      .checkBoxWrapper {
                        svg {
                          height: 16px;
                          width: auto;
                          path {
                            fill: ${nota.color.main.mThree};
                          }
                        }
                      }
                      p {
                        font-size: 12px;
                      }
                    }
                    .selectedFav {
                      background-color: ${nota.color.main.mThree};
                      .checkBoxWrapper {
                        svg {
                          path {
                            fill: ${nota.color.neutral.white};
                          }
                        }
                      }
                    }
                  }
                }
                .optionsWrapper {
                  height: auto;
                  margin: ${multiple * 2 + "px"} 0;
                  svg {
                    width: 16px;
                    height: 16px;
                    margin: ${multiple + "px"};
                    cursor: pointer;
                    path {
                      fill: ${nota.color.neutral.NeuOne};
                    }
                    &:hover {
                      path {
                        fill: ${nota.color.main.default};
                      }
                    }
                    &:last-child {
                      margin-right: 0;
                    }
                  }
                  .deleteBtn {
                    &:hover {
                      path {
                        fill: ${nota.color.main.mTwo};
                      }
                    }
                  }
                }
              }
            }
            .searchBtnWrapper {
              width: ${multiple * 7 + "px"};
              background-color: ${nota.color.main.default};
              cursor: pointer;
              .iconContainer {
                svg {
                  width: 25px;
                  height: 25px;
                  path {
                    fill: ${nota.color.neutral.white};
                  }
                }
              }
              &:hover {
                opacity: 0.7;
              }
            }
          }

          .bottomOptionsWrapper {
            padding: ${multiple + "px"} ${multiple * 2 + "px"};
            background-color: ${nota.color.neutral.lightGrey};
            height: auto;
            .dateContainer {
              .dateWrapper {
                width: auto;
                margin-right: 8px;
                svg {
                  width: auto;
                  height: 12px;
                  margin-right: 4px;
                  path {
                    fill: ${nota.color.neutral.NeuOne};
                  }
                }
                &:last-child {
                  margin-right: 0;
                }
              }
            }
            .bottomIcons {
              height: auto;

              svg {
                width: 14px;
                height: 14px;
                margin: 0 ${multiple + "px"};
                cursor: pointer;
                path {
                  fill: ${nota.color.neutral.NeuOne};
                }
                &:hover {
                  path {
                    fill: ${nota.color.main.default};
                  }
                }
                &:last-child {
                  margin-right: 0;
                }
              }
              .deleteBtn {
                &:hover {
                  path {
                    fill: ${nota.color.main.mTwo};
                  }
                }
              }
              .optionsItem {
                display: flex;
              }
              .optionsItemShared {
                display: none;
              }
            }
          }
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  /* NO ITEMS LIST INFO */
  .noItemsListInfo {
    height: calc(100vh - 176px);
    background-color: ${nota.color.neutral.NeuFour};
    margin-top: 16px;
    h2 {
      text-transform: uppercase;
    }
  }

  /* MEDIA QUERIES */
  @media only screen and (max-width: 890px) {
    .dateContainer {
      flex-direction: column;
    }
  }
  @media only screen and (max-width: 800px) {
    .headerWrapper {
      flex-direction: column;
      align-items: flex-start;
      p {
        margin-top: ${multiple + "px"};
        margin-left: 0px;
        margin-bottom: 0px;
      }
    }
    .secondaryWrapper {
      margin: 24px 0;
      .inputWrapper {
        width: 100%;
      }
    }

    .listContainer {
      .itemContainer {
        .wrapperList {
          .wrapperListContainer {
            .asidesWrapper {
              flex-direction: column;
            }
            .rightAsideItem {
              width: 100%;
              padding-bottom: 4px;
              .optionsItemWrapper {
                .optionsContainer {
                  width: 100%;
                  .btnsWrapper {
                    flex-direction: row;
                    justify-content: space-between;
                    .selectsWrapper {
                      align-items: flex-start;
                      justify-content: flex-start;
                      .selectBtn {
                        width: 100%;
                      }
                    }
                    .favBtn {
                      margin-top: 0px;
                      margin-bottom: 8px;
                      justify-content: flex-end;
                      .optionWrapper {
                        height: auto;
                        .checkBoxWrapper {
                          width: auto;
                          height: auto;
                          padding: 0;
                        }
                      }
                      p {
                        display: none;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    .noItemsListInfo {
      height: calc(100vh - 239px);
    }
  }
  @media only screen and (max-width: 460px) {
    .bottomOptionsWrapper {
      flex-direction: column;
      .infoContainer {
        justify-content: flex-start;
        align-items: flex-start;
        .programmesNumber {
          justify-content: flex-start;
        }
      }
    }
  }

  @media only screen and (max-width: 368px) {
    .listContainer {
      .itemContainer {
        .wrapperList {
          .wrapperListContainer {
            .rightAsideItem {
              .optionsItemWrapper {
                .optionsContainer {
                  .btnsWrapper {
                    .selectBtn {
                      width: 100%;
                      .optionWrapper {
                        padding: 6px;
                        p {
                          font-size: 12px;
                        }
                      }
                    }
                    .favBtn {
                      margin-left: 8px;
                      max-width: 38px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const StyledLoading = styled(NanoFlex)`
  height: calc(100vh - 98px);
`;

export class SavedSearchItem extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      programs: null,
      programsCount: null,
    };
  }

  componentDidMount() {
    super.componentDidMount();
    window.addEventListener("languageChange", this.onSavedSearchItemLanguageChange, false);

    this.getAllData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (JSON.stringify(prevProps.savedSearch) !== JSON.stringify(this.props.savedSearch)) {
      this.getAllData();
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    window.removeEventListener("languageChange", this.onSavedSearchItemLanguageChange, false);
  }

  onSavedSearchItemLanguageChange = () => {
    this.getAllData();
  };

  getAllData = () => {
    this.getPrograms();
  };

  getPrograms = () => {
    if (this.props.savedSearch.filter) {
      searchService
        .getAdvancedSearchPrograms({ ...this.props.savedSearch.filter, ...{ Page: 1, ResultsPerPage: 7, SearchFrom: "SavedSearch", SavedSearchId: this.props.savedSearch.id, LastCall: this.props.savedSearch.lastCall } })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            // Catch
            if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
          }
        })
        .then((data) => {
          this.setState({ programs: data.programs, programsCount: data.count });
        });
    } else {
      this.setState({ programs: [] });
    }
  };

  canShow = () => {
    if (this.props.term.trim() !== "") {
      let upperTerm = this.props.term.trim().toUpperCase();
      let upperName = this.props.savedSearch.searchName.trim().toUpperCase();
      return upperName.startsWith(upperTerm);
    }
    return true;
  };

  onDeleteClick = () => {
    if (this.props.onDelete) {
      this.props.onDelete(this.props.savedSearch);
    }
  };

  onDuplicateClick = () => {
    if (this.props.onDuplicate) {
      this.props.onDuplicate(this.props.savedSearch);
    }
  };

  onEditClick = () => {
    if (this.props.onEdit) {
      this.props.onEdit(this.props.savedSearch);
    }
  };

  onShowInHomepageClick = () => {
    if (this.props.onShowInHomepage) {
      this.props.onShowInHomepage(this.props.savedSearch);
    }
  };

  onDailyUpdateClick = () => {
    if (this.props.onDailyUpdate) {
      this.props.onDailyUpdate(this.props.savedSearch);
    }
  };

  onFavoriteClick = () => {
    if (this.props.onFavorite) {
      this.props.onFavorite(this.props.savedSearch);
    }
  };

  onSearchClick = () => {
    window.dispatchEvent(new CustomEvent("setSearchFrom", { detail: { id: this.props.savedSearch.id, menu: "SavedSearch", lastCall: this.props.savedSearch.lastCall, filter: this.props.savedSearch.filter } }));
  };

  render() {
    if (this.canShow() == false) return null;

    return (
      <NanoFlex className="itemContainer" alignItems={"stretch"} key={this.props.savedSearch.id}>
        <WrapperList className="wrapperList">
          <ViewMore onClick={this.onSearchClick} />

          <NanoFlex className="wrapperListContainer" flexDirection={"column"} alignItems={"stretch"}>
            {/* ASIDES  */}
            <NanoFlex className="asidesWrapper">
              <NanoFlex className="leftAsideItem" flexDirection={"column"} justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"flex-start"}>
                <NanoFlex className="titleCard" justifyContent={"flex-start"}>
                  <Type.h3 title={this.props.savedSearch.searchName}>
                    <b>{this.props.savedSearch.searchName}</b>
                  </Type.h3>
                </NanoFlex>
                <NanoFlex className="descriptionWrapper" justifyContent={"flex-start"}>
                  {this.props.savedSearch.description && <Type.p title={this.props.savedSearch.description}>{this.props.savedSearch.description}</Type.p>}
                </NanoFlex>
                {/* GRID */}
                <NanoFlex className="gridContainer">
                  {this.state.programs?.length > 0 && <Grid className="gridItem" data={this.state.programs} row={1} />}
                  {this.state.programs?.length == 0 && (
                    <NanoFlex className="emptyGrid">
                      <Type.p>No items</Type.p>
                    </NanoFlex>
                  )}

                  {!this.state.programs && (
                    <NanoFlex className="loadingGrid">
                      <Spinner />
                    </NanoFlex>
                  )}
                </NanoFlex>
                {/* END GRID */}
              </NanoFlex>

              <NanoFlex className="rightAsideItem" flexDirection={"row"} justifyContent={"flex-end"} alignContent={"flex-end"} alignItems={"flex-end"}>
                <NanoFlex className="optionsItemWrapper" alignItems={"stretch"}>
                  <NanoFlex className="optionsContainer" flexDirection={"column"}>
                    <NanoFlex className="btnsWrapper" flexDirection="column" justifyContent={"flex-end"} alignContent={"flex-end"} alignItems={"flex-end"}>
                      <NanoFlex className="selectsWrapper" flexDirection="column">
                        <NanoFlex className="selectBtn" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
                          <NanoFlex className={`optionWrapper ${this.props.savedSearch.showInHomepage ? "selectedOption" : ""}`} justifyContent="flex-start" onClick={this.onShowInHomepageClick}>
                            <NanoFlex className="checkBoxWrapper" justifyContent="flex-start">
                              <Check />
                            </NanoFlex>
                            <Type.p>{this.translation.savedSearch.displayOnHomepage}</Type.p>
                          </NanoFlex>
                        </NanoFlex>

                        <NanoFlex className="selectBtn" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
                          <NanoFlex className={`optionWrapper ${this.props.savedSearch.dailyUpdate ? "selectedOption" : ""}`} justifyContent="flex-start" onClick={this.onDailyUpdateClick}>
                            <NanoFlex className="checkBoxWrapper" justifyContent="flex-start">
                              <Check />
                            </NanoFlex>
                            <Type.p>{this.translation.savedSearch.addToDailyUpdate}</Type.p>
                          </NanoFlex>
                        </NanoFlex>

                        <NanoFlex className="selectBtn" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
                          <NanoFlex className={`optionWrapper ${this.props.savedSearch.isFavorite ? "selectedOption" : ""}`} justifyContent="flex-start" onClick={this.onFavoriteClick}>
                            <NanoFlex className="checkBoxWrapper" justifyContent="flex-start">
                              <Check />
                            </NanoFlex>
                            <Type.p>{this.translation.savedSearch.addToFavorites}</Type.p>
                          </NanoFlex>
                        </NanoFlex>
                      </NanoFlex>

                      {/* FAVORITE BTN */}
                      {/* <NanoFlex className="selectBtn favBtn" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
                        <NanoFlex className={`optionWrapper ${this.props.savedSearch.isFavorite ? "selectedFav" : ""}`} justifyContent="center" onClick={this.onFavoriteClick}>
                          <NanoFlex className="checkBoxWrapper" justifyContent="flex-start">
                            <Favorite />
                          </NanoFlex>
                          {this.props.savedSearch.isFavorite && <Type.p>ADDED TO FAVORITES</Type.p>}
                          {!this.props.savedSearch.isFavorite && <Type.p>ADD TO FAVORITES</Type.p>}
                        </NanoFlex>
                      </NanoFlex> */}
                      {/* END FAVORITE BTN */}
                    </NanoFlex>
                  </NanoFlex>
                </NanoFlex>
              </NanoFlex>
            </NanoFlex>
            {/* END ASIDES  */}
            {/* BOTTOM OPTIONS */}
            <NanoFlex className="bottomOptionsWrapper">
              <NanoFlex className="dateContainer" justifyContent={"flex-start"} alignItems={"flex-start"}>
                <NanoFlex className="dateWrapper" justifyContent={"flex-start"}>
                  <CreatDate />
                  <Type.p>{this.props.savedSearch.creationDate}</Type.p>
                </NanoFlex>
                <NanoFlex className="dateWrapper" justifyContent={"flex-start"}>
                  <EditDate />
                  <Type.p>{this.props.savedSearch.updateDate}</Type.p>
                </NanoFlex>
              </NanoFlex>
              <NanoFlex className="infoContainer">
                <NanoFlex className="programmesNumber">
                  <Type.p>
                    {this.state.programsCount ?? "-"} {this.state.programsCount > 1 ? this.translation.geral.programmes : this.translation.geral.programme}
                  </Type.p>
                </NanoFlex>
              </NanoFlex>
              <NanoFlex className="bottomIcons" justifyContent={"flex-end"}>
                <NanoFlex className="optionsItem" justifyContent={"flex-end"}>
                  <Edit title={this.translation.geral.edit} onClick={this.onEditClick} />
                  <Duplicate title={this.translation.geral.duplicate} onClick={this.onDuplicateClick} />
                  <Delete title={this.translation.geral.continue} className="deleteBtn" onClick={this.onDeleteClick} />
                </NanoFlex>
              </NanoFlex>
            </NanoFlex>
            {/* END BOTTOM OPTIONS */}
          </NanoFlex>
        </WrapperList>
      </NanoFlex>
    );
  }
}

export class SavedSearchesManagement extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      term: "",
      savedSearches: null,
      savedSearchToEdit: null,
      savedSearchToDelete: null,
      showInHomepageMaxExceeded: false,
      favoriteMaxExceeded: false,
    };
  }

  componentDidMount() {
    super.componentDidMount();
    window.addEventListener("languageChange", this.onSavedSearchLanguageChange, false);
    window.addEventListener("saveSearch", this.onSaveSearch, false);

    this.getAllComponentsData();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    window.removeEventListener("languageChange", this.onSavedSearchLanguageChange, false);
    window.removeEventListener("saveSearch", this.onSaveSearch, false);
  }

  onSavedSearchLanguageChange = () => {
    this.getAllComponentsData();
  };

  onSaveSearch = () => {
    this.getAllComponentsData();
  };

  getAllComponentsData = () => {
    this.getSavedSearches();
  };

  getSavedSearches = () => {
    searchService
      .getSavedSearches()
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ savedSearches: data });
      });
  };

  onTermChange = (value) => {
    this.setState({ term: value });
  };

  onSavedSearchEdit = (item) => {
    this.setState({ savedSearchToEdit: item });
  };

  onSavedSearchDelete = (item) => {
    this.setState({ savedSearchToDelete: item });
  };

  confirmSavedSearchDelete = () => {
    searchService
      .deleteSearch(this.state.savedSearchToDelete.id)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        if (this.state.savedSearchToDelete.isFavorite) {
          /*Reload Navbar SavedSearches*/
          window.dispatchEvent(new Event("reloadNavbarSavedSearches"));
        }

        this.setState({ savedSearchToDelete: null }, () => {
          /*Get New Data */
          this.getAllComponentsData();
          /*Trigger Saved Search Change event */
          window.dispatchEvent(new Event("saveSearch"));
        });
      });
  };

  onSavedSearchDuplicate = (item) => {
    searchService
      .duplicateSearch(item.id)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        /*Get New Data */
        this.getAllComponentsData();
        /*Trigger Saved Search Change event */
        window.dispatchEvent(new Event("saveSearch"));
      });
  };

  onShowInHomepage = (item) => {
    let immutableData = JSON.parse(JSON.stringify(this.state.savedSearches));
    let itemData = immutableData.find((l) => l.id == item.id);
    itemData.showInHomepage = !itemData.showInHomepage;
    if (immutableData.filter((l) => l.showInHomepage).length <= 2) {
      this.setState({ savedSearches: immutableData }, () => {
        this.saveShowInHomepage();
      });
    } else {
      this.setState({ showInHomepageMaxExceeded: true });
    }
  };

  saveShowInHomepage = () => {
    searchService
      .setSearchShowInHomepage(this.state.savedSearches.filter((l) => l.showInHomepage).map((l) => l.id))
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        /*Get New Data */
        this.getAllComponentsData();
      });
  };

  onDailyUpdate = (item) => {
    let immutableData = JSON.parse(JSON.stringify(this.state.savedSearches));
    let itemData = immutableData.find((l) => l.id == item.id);
    itemData.dailyUpdate = !itemData.dailyUpdate;
    this.setState({ savedSearches: immutableData }, () => {
      this.saveDailyUpdate(itemData.id, itemData.dailyUpdate);
    });
  };

  saveDailyUpdate = (idSearch, state) => {
    searchService
      .setSearchDailyUpdate(idSearch, state)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        /*Get New Data */
        this.getAllComponentsData();
      });
  };

  onFavorite = (item) => {
    let immutableData = JSON.parse(JSON.stringify(this.state.savedSearches));
    let itemData = immutableData.find((l) => l.id == item.id);
    itemData.isFavorite = !itemData.isFavorite;
    if (immutableData.filter((l) => l.isFavorite).length <= 5) {
      this.setState({ savedSearches: immutableData }, () => {
        //To Do Later
        this.saveFavorite();
      });
    } else {
      this.setState({ favoriteMaxExceeded: true });
    }
  };

  saveFavorite = () => {
    searchService
      .setSearchFavorites(this.state.savedSearches.filter((l) => l.isFavorite).map((l) => l.id))
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        /*Get New Data */
        this.getAllComponentsData();
        /*Reload Navbar SavedSearches*/
        window.dispatchEvent(new Event("reloadNavbarSavedSearches"));
      });
  };

  render() {
    if (this.state.savedSearches == null)
      return (
        <StyledLoading className="loadingContainer">
          <Loading />
        </StyledLoading>
      );

    return (
      <StyledSavedSearchesManagement>
        <NanoFlex className="viewWrapper" flexDirection={"column"} justifyContent={"flex-start"}>
          <NanoFlex className="headerWrapper" justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"flex-end"}>
            <Type.h2>
              <em>{this.translation.savedSearch.title}</em>
            </Type.h2>
            <Type.p>{this.translation.savedSearch.subTitle}</Type.p>
          </NanoFlex>
          {this.state.savedSearches?.length > 0 && (
            <NanoFlex className="secondaryWrapper" justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"flex-start"}>
              <NanoFlex className="inputWrapper" justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"flex-start"}>
                <Input title={null} defaultValue={this.state.term} placeholder={this.translation.savedSearch.searchSavedSearchPlaceholder} onChangeAction={this.onTermChange} />
                <NanoFlex className="searchIconWrapper">
                  <SearchIcon />
                </NanoFlex>
              </NanoFlex>
            </NanoFlex>
          )}

          {/*LIST*/}
          <NanoFlex className="listContainer" flexDirection={"column"} justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"flex-start"}>
            {/* ITEM  */}
            {this.state.savedSearches &&
              this.state.savedSearches.map((item) => {
                return (
                  <SavedSearchItem
                    savedSearch={item}
                    key={item.id}
                    term={this.state.term}
                    onDuplicate={this.onSavedSearchDuplicate}
                    onDelete={this.onSavedSearchDelete}
                    onEdit={this.onSavedSearchEdit}
                    onShowInHomepage={this.onShowInHomepage}
                    onDailyUpdate={this.onDailyUpdate}
                    onFavorite={this.onFavorite}></SavedSearchItem>
                );
              })}
            {/* END ITEM  */}
          </NanoFlex>
          {/* END LIST  */}
          {/* EMPTY LIST INFO  */}
          {this.state.savedSearches?.length == 0 && (
            <NanoFlex className="noItemsListInfo">
              <Type.h2>EMPTY lIST</Type.h2>
            </NanoFlex>
          )}

          {/* END EMPTY LIST INFO  */}

          {this.state.savedSearchToEdit && (
            <Modal
              show={true}
              content={
                <EditSavedSearchModal
                  savedSearch={this.state.savedSearchToEdit}
                  cancelAction={() => {
                    this.setState({ savedSearchToEdit: null });
                  }}
                  nextAction={() => {
                    if (this.state.savedSearchToEdit.isFavorite) {
                      /*Reload Navbar SavedSearches*/
                      window.dispatchEvent(new Event("reloadNavbarSavedSearches"));
                    }

                    this.setState({ savedSearchToEdit: null }, () => {
                      this.getAllComponentsData();
                      /*Trigger Saved Search Change event */
                      window.dispatchEvent(new Event("saveSearch"));
                    });
                  }}
                />
              }
            />
          )}

          {this.state.savedSearchToDelete && (
            <Modal
              show={true}
              content={
                <DeleteContent
                  field={this.state.savedSearchToDelete.searchName}
                  cancelAction={() => {
                    this.setState({ savedSearchToDelete: null });
                  }}
                  nextAction={this.confirmSavedSearchDelete}
                />
              }
            />
          )}

          <Modal
            show={this.state.showInHomepageMaxExceeded}
            content={
              <ModalContent
                message={<Type.p dangerouslySetInnerHTML={{ __html: this.translation.savedSearch.maxHomepageExceeded }}></Type.p>}
                actions={[
                  {
                    label: this.translation.geral.continue,
                    action: () => {
                      this.setState({ showInHomepageMaxExceeded: false });
                    },
                    simple: false,
                  },
                ]}
              />
            }
          />

          <Modal
            show={this.state.favoriteMaxExceeded}
            content={
              <ModalContent
                message={
                  <Type.p>
                    Maximum of <b>5 Saved Searches</b>
                    <br /> to be added to Favorites
                  </Type.p>
                }
                actions={[
                  {
                    label: this.translation.geral.continue,
                    action: () => {
                      this.setState({ favoriteMaxExceeded: false });
                    },
                    simple: false,
                  },
                ]}
              />
            }
          />
        </NanoFlex>
      </StyledSavedSearchesManagement>
    );
  }
}
